module.exports = __webpack_public_path__ + "img/12-1_02.beec2cfb.jpg";